export function scrollToTopFrom(element) {
  if (typeof window === 'undefined' || !element) {
    return
  }

  const target = findVerticalScrollContainer(element)
  if (!target) {
    return
  }

  if (
    target === window ||
    target === document.scrollingElement ||
    target === document.documentElement ||
    target === document.body
  ) {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
    return
  }

  target.scrollTo({ top: 0, left: 0, behavior: 'auto' })
}

function findVerticalScrollContainer(element) {
  let current = element

  while (current && current !== document.body) {
    const style = window.getComputedStyle(current)
    const canScrollY = ['auto', 'scroll', 'overlay'].includes(style.overflowY)

    if (canScrollY && current.scrollHeight > current.clientHeight) {
      return current
    }

    current = current.parentElement
  }

  return document.scrollingElement || document.documentElement || window
}
